import "./style.css";
import React, { Fragment, useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { login, checkEmailBeforeRegister, newLogin, loadUser } from "../../actions/auth";
import { useHistory, useLocation } from "react-router-dom";
import googleIcon from "../../images/google-icon.svg";
import CustomerRegister from "./CustomerRegister";
import { useTranslation } from "react-i18next";
import { useLoading } from "../LoadingContext";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { EyeIcon, EyeOffIcon, EmailIcon, LockIcon, ProfileIcon } from "../icons";
import { useRef } from "react";
import i18next from "i18next";
import { isTokenValid, checkTokenUser } from "../../utils/authUtils";
import { useDisclosure, useGoogleSignIn } from "../../hooks";
import { FiArrowRight } from "react-icons/fi";
import { ModalCloseButton } from "../motion";
import "./motion-modal.css";


const CustomerLogin = ({
  // login,
  // isAuthenticated,
  useModal,
  isRegister,
  setIsRegister,
  modalId,
  isBooking,
  book,
  autoOpen = false,
  isQuotation = false,
  redirect = "/"
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loginFailed, setLoginFailed] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  let registerFormQuery = queryParams.get("is_register");

  const settings = useSelector((state) => state.setting);
  const { lang } = settings;

  const changeLanguage = (lng) => {
    i18next.changeLanguage(lng.toLowerCase());
  };

  useEffect(() => {
    if (!isQuotation && isTokenValid() && checkTokenUser()) {
      history.push("/my-page/bookings");
    } else {
      const lang = localStorage.getItem("lang");
      if (lang !== null) changeLanguage(lang);
    }
  }, []);

  const modalRef = useRef(null);
  useEffect(() => {
    if (autoOpen) {
      // Check if the global bootstrap object is available
      const bootstrap = window.bootstrap;
      const modalElement = modalRef.current;

      if (bootstrap && modalElement) {
        // Initialize the modal programmatically
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }, [autoOpen]);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [formDataRegister, setFormDataRegister] = useState({
    email: "",
    password: "",
    password_confirmation: "",
    sign_up_with_google: false,
    access_token_google: null,
    avatar: null,
  });
  const [isGoogleSignUp, setIsGoogleSignUp] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const { email, password } = formData;
  const { showLoading, closeLoading } = useLoading();
  const showLoadingDisclosure = useDisclosure();
  const buttonCLoseModalLogin = document.getElementById("closeModalLogin");
  const [loginErrorMsg, setLoginErrorMsg] = useState("");

  const resetState = () => {
    setFormDataRegister({
      email: "",
      password: "",
      password_confirmation: "",
      sign_up_with_google: false,
      access_token_google: null,
      avatar: null,
    });
    setFormData({
      email: "",
      password: "",
    });
    setIsGoogleSignUp(false);
    setLoginFailed(false);
  };

  const handleGoogleCredential = async ({ credential, email: userEmail, picture: userImageURL }) => {
    try {
      // `credential` is the Google ID token (JWT). The backend verifies it and
      // derives the email itself; `userEmail`/`userImageURL` come from the
      // decoded token and are only used for the registration prefill.
      showLoading(true);
      const checkLoginWithGoogle = await newLogin(
        userEmail,
        credential,
        "google"
      );

      if (checkLoginWithGoogle.status !== 200) {
        switch (checkLoginWithGoogle.data.status) {
          case "USER_NOT_FOUND":
            const checkEmailStatus = await checkEmailBeforeRegister({
              ...formDataRegister,
              sign_up_with_google: true,
              email: userEmail,
              access_token_google: credential,
              avatar: userImageURL,
              role: "individual"
            })

            if (checkEmailStatus.data.code === 200) {
              setFormDataRegister({
                ...formDataRegister,
                sign_up_with_google: true,
                email: userEmail,
                access_token_google: credential,
                avatar: userImageURL,
              });
              setIsGoogleSignUp(true);
            } else {
              setLoginErrorMsg(checkEmailStatus.data.desc);
              setLoginFailed(true);
              closeLoading(true);
            }
            break;

          default:
            setLoginErrorMsg(checkLoginWithGoogle.data.message);
            setLoginFailed(true);
            closeLoading(true);
            break;
        }
      } else {
        dispatch(loadUser());
        closeLoading(true);
        // buttonCLoseModalLogin.click();
        window.location.reload();
        // if (redirect) {
        //   history.push(redirect)
        // } else {
        //   window.location.reload();
        // }
      }
    } catch (error) {
      console.error("Error signing in:", error);
      console.log("Error details:", JSON.stringify(error, null, 2));
    }
  };

  const { signIn: handleSignInGoogle, hiddenButtonRef } =
    useGoogleSignIn(handleGoogleCredential);

  useEffect(() => {
    if (isGoogleSignUp) {
      closeLoading(true);
      buttonCLoseModalLogin.click();

      history.push({
        pathname: "/register",
        state: { formData: formDataRegister },
      });
    }
  }, [isGoogleSignUp, formDataRegister]);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };

  const togglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  };

  const onSubmit = async (e) => {
    showLoadingDisclosure.onOpen();
    e.preventDefault();
    const res = await newLogin(email, password);

    if (res.status !== 200) {
      setLoginErrorMsg(res.data.message);
      setLoginFailed(true);
      showLoadingDisclosure.onClose();
    } else {
      dispatch(loadUser());
      showLoadingDisclosure.onClose();
      window.location.reload()
      // buttonCLoseModalLogin.click();
      // if (redirect) {
      //   history.push(redirect)
      // } else {
      // window.location.reload()
      // }
    }
  };

  // if (isAuthenticated) {
  //   if (isBooking) {
  //     resetState();
  //     book();
  //   } else if (isQuotation) {
  //     // reload the page
  //     window.location.reload(true);
  //   } else {
  //     resetState();
  //     closeLoading(true);
  //     buttonCLoseModalLogin.click();
  //     window.location.reload()
  //   }
  // }

  return (
    <Fragment>
      {/* Off-screen Google Identity Services button, clicked programmatically
          by the visible "Continue with Google" buttons below. */}
      <div
        ref={hiddenButtonRef}
        aria-hidden="true"
        style={{ position: "absolute", left: "-9999px", top: "-9999px" }}
      ></div>
      {/* {!useModal && (
        <h2 className="tw:block tw:md:hidden">
          {isRegister == true || registerFormQuery == "true"
            ? t("sign_up.sign_up")
            : t("login.login")}
        </h2>
      )} */}
      {useModal ? (
        <div
          className="modal fade tlf-motion-modal"
          id={modalId}
          tabIndex="0"
          aria-labelledby="loginLabel"
          aria-hidden="true"
          ref={modalRef}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered ">
            <div className="modal-content">
              <div className="modal-body tw:!p-7">
                <div className="tw:flex tw:justify-between tw:items-center tw:pb-6 tw:border-b tw:border-b-[#EEEEEE] tw:mb-6">
                  <div className="tw:font-hanken-grotesk tw:font-semibold tw:text-lg">
                    {t("login.login")}
                  </div>
                  {isQuotation !== true && (
                    <div className="">
                      <ModalCloseButton isInline data-bs-dismiss="modal" id="closeModalLogin" />
                    </div>
                  )}
                </div>
                {/* START FORM */}
                {loginFailed && (
                  <>
                    <div className="alert alert-invalid">
                      <p className="mb-0 text-invalid">
                        <i className="fa fa-warning me-2"></i>
                        {t(loginErrorMsg)}
                      </p>
                    </div>
                  </>
                )}
                <form onSubmit={(e) => onSubmit(e)} action="#">
                  <div className="tw:space-y-3">
                    <div className="tw:relative tw:border tw:border-[#C9C9C9] tw:rounded-md tw:h-[54px] tw:flex tw:items-center tw:px-[15px]">
                      <div className="tw:py-[10px] tw:w-[27px]">
                        <EmailIcon />
                      </div>
                      <div className="tw:relative tw:w-full tw:h-full tw:flex tw:items-center tw:py-[10px]">
                        <input
                          type="text"
                          id="customer_login_modal_email_address"
                          name="email"
                          placeholder=" "
                          onChange={(e) => onChange(e)}
                          className="tw:block tw:appearance-none tw:peer tw:w-full tw:outline-none tw:!mt-4 tw:!text-sm"
                        />
                        <label
                          htmlFor="customer_login_modal_email_address"
                          className="tw:cursor-text tw:absolute tw:text-sm tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:duration-300 tw:transform tw:-translate-y-4 tw:scale-75 tw:pt-2 tw:top-4 tw:z-10 tw:origin-[0]
                                  tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:translate-y-0 tw:peer-placeholder-shown:pt-0
                                  tw:peer-focus:scale-75 tw:peer-focus:-translate-y-4 tw:peer-focus:pt-2
                                   tw:w-full
                                  "
                        >
                          {t("login.email_address")}
                        </label>
                      </div>
                    </div>
                    <div className="tw:relative tw:border tw:border-[#C9C9C9] tw:rounded-md tw:h-[54px] tw:flex tw:items-center tw:px-[15px]">
                      <div className="tw:py-[10px] tw:w-[27px]">
                        <LockIcon />
                      </div>
                      <div className="tw:relative tw:w-full tw:h-full tw:flex tw:items-center tw:py-[10px]">
                        <input
                          type={showPassword1 ? "text" : "password"}
                          id="customer_login_modal_password"
                          name="password"
                          placeholder=" "
                          onChange={(e) => onChange(e)}
                          className="tw:block tw:appearance-none tw:peer tw:w-full tw:outline-none tw:!mt-4 tw:!text-sm"
                        />
                        <label
                          htmlFor="customer_login_modal_password"
                          className="tw:cursor-text tw:absolute tw:text-sm tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:duration-300 tw:transform tw:-translate-y-4 tw:scale-75 tw:pt-2 tw:top-4 tw:z-10 tw:origin-[0] 
                                  tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:translate-y-0 tw:peer-placeholder-shown:pt-0
                                  tw:peer-focus:scale-75 tw:peer-focus:-translate-y-4 tw:peer-focus:pt-2
                                   tw:w-full
                                  "
                        >
                          {t("login.password")}
                        </label>
                        <div
                          onClick={togglePasswordVisibility1}
                          style={{
                            position: 'absolute',
                            right: '16px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 5,
                            display: 'flex',
                            alignItems: 'center',
                            padding: '4px'
                          }}
                        >
                          {showPassword1 ? (
                            <EyeIcon />
                          ) : (
                            <EyeOffIcon />
                          )}
                        </div>
                      </div>
                    </div>
                    <a
                      href="/forgot-password"
                      className="tw:font-hanken-grotesk tw:!text-[#8D8D8D] tw:italic tw:text-sm"
                    >
                      {t("login.forgot_password")}
                    </a>
                  </div>
                  <div className="tw:!space-y-3 tw:mt-6 tw:text-center">
                    <button
                      name=""
                      id=""
                      type="submit"
                      className="tw:!w-full tw:!bg-[#D4B055] tw:h-[50px] tw:!rounded-md tw:!text-white tw:!flex tw:items-center tw:!justify-center tw:gap-[10px] tw:leading-5"
                      href="#"
                      role="button"
                    >
                      {showLoadingDisclosure.isOpen ? <div className="loading-spinner"></div> : (
                        <>
                          <div className="tw:font-hanken-grotesk tw:font-bold tw:text-sm">
                            {t("login.login")}
                          </div>
                          <FiArrowRight size={24} />
                        </>
                      )}

                    </button>
                    <div>
                      <a
                        href="#"
                        className="tw:!no-underline"
                        data-bs-dismiss="modal"
                        data-bs-toggle="modal"
                        data-bs-target="#register"
                        style={{ fontSize: "14px" }}
                      >
                        <span
                          className="tw:font-hanken-grotesk tw:text-[#212529]"
                          dangerouslySetInnerHTML={{
                            __html: t("login.sign_up_link"),
                          }}
                        ></span>
                      </a>
                    </div>
                  </div>
                </form>

                <div className="tw:flex tw:items-center tw:space-x-4 tw:mt-6">
                  <div className="tw:bg-[#EEEEEE] tw:h-[1px] tw:flex-1"></div>
                  <div className="tw:font-hanken-grotesk tw:text-[#212529] tw:text-sm tw:whitespace-nowrap tw:flex-shrink-0 tw:capitalize">
                    {t("login.or_google")}
                  </div>
                  <div className="tw:bg-[#EEEEEE] tw:h-[1px] tw:flex-1"></div>
                </div>

                <div className="justify-content-center tw:mt-6">
                  <div>
                    <a
                      name=""
                      id=""
                      className="tw:!h-[50px] tw:flex tw:items-center tw:justify-center tw:rounded-md tw:border tw:border-[#8D8D8D] tw:!no-underline tw:space-x-[10px]"
                      role="button"
                      onClick={handleSignInGoogle}
                    >
                      <img
                        src={googleIcon}
                        className="img-fluid"
                        alt="Efficiency"
                      />
                      <span className="tw:font-hanken-grotesk tw:text-[#282828] tw:text-sm">
                        {t("login.continue_w_google")}
                      </span>
                    </a>
                  </div>
                  {isBooking ? (
                    <div className="col-6 d-grid text-center ">
                      <button
                        type="button"
                        name=""
                        id=""
                        className="btn btn-secondary rounded py-2 px-4 m-0"
                        href="#"
                        role="button"
                        onClick={book}
                        data-bs-dismiss="modal"
                      >
                        <ProfileIcon />
                        &nbsp; {t("login.continue_as_guest")}
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                {/* END FORM */}
              </div>
            </div>
          </div>
        </div>
      ) : isRegister == true || registerFormQuery == "true" ? (
        <CustomerRegister setIsRegister={setIsRegister} />
      ) : (
        <>
          {loginFailed && (
            <>
              <div className="alert alert-invalid">
                <p className="mb-0 text-invalid">
                  <i className="fa fa-warning me-2"></i>
                  {t(loginErrorMsg)}
                </p>
              </div>
            </>
          )}
          <form onSubmit={(e) => onSubmit(e)} action="#" className="tw:mx-5">
            <div className="">
              <div className="tw:flex tw:justify-between tw:items-center tw:pb-6 tw:border-b tw:border-b-[#EEEEEE] tw:mb-6">
                <div className="tw:font-hanken-grotesk tw:font-semibold tw:text-lg">
                  {t("login.login")}
                </div>
                {isQuotation !== true && (
                  <div className="">
                    <button
                      type="button"
                      className="btn-close"
                      onClick={history.goBack}
                    ></button>
                  </div>
                )}
              </div>
              {/* START FORM */}
              {loginFailed && (
                <>
                  <div className="alert alert-danger">{t(loginErrorMsg)}</div>
                </>
              )}
              <form onSubmit={(e) => onSubmit(e)} action="#">
                <div className="tw:space-y-3">
                  <div className="tw:relative tw:border tw:border-[#C9C9C9] tw:rounded-md tw:h-[54px] tw:flex tw:items-center tw:px-[15px]">
                    <div className="tw:py-[10px] tw:w-[27px]">
                      <EmailIcon />
                    </div>
                    <div className="tw:relative tw:w-full tw:h-full tw:flex tw:items-center tw:py-[10px]">
                      <input
                        type="text"
                        id="customer_login_mobile_email_address"
                        name="email"
                        placeholder=" "
                        onChange={(e) => onChange(e)}
                        className="tw:block tw:appearance-none tw:peer tw:w-full tw:outline-none tw:!mt-4 tw:!text-sm"
                      />
                      <label
                        htmlFor="customer_login_mobile_email_address"
                        className="tw:cursor-text tw:absolute tw:text-sm tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:duration-300 tw:transform tw:-translate-y-4 tw:scale-75 tw:pt-2 tw:top-4 tw:z-10 tw:origin-[0]
                                  tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:translate-y-0 tw:peer-placeholder-shown:pt-0
                                  tw:peer-focus:scale-75 tw:peer-focus:-translate-y-4 tw:peer-focus:pt-2
                                   tw:w-full
                                  "
                      >
                        {t("login.email_address")}
                      </label>
                    </div>
                  </div>
                  <div className="tw:relative tw:border tw:border-[#C9C9C9] tw:rounded-md tw:h-[54px] tw:flex tw:items-center tw:px-[15px]">
                    <div className="tw:py-[10px] tw:w-[27px]">
                      <LockIcon />
                    </div>
                    <div className="tw:relative tw:w-full tw:h-full tw:flex tw:items-center tw:py-[10px]">
                      <input
                        type={showPassword2 ? "text" : "password"}
                        id="customer_login_mobile_password"
                        name="password"
                        placeholder=" "
                        onChange={(e) => onChange(e)}
                        className="tw:block tw:appearance-none tw:peer tw:w-full tw:outline-none tw:!mt-4 tw:!text-sm"
                      />
                      <label
                        htmlFor="customer_login_mobile_password"
                        className="tw:cursor-text tw:absolute tw:text-sm tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:duration-300 tw:transform tw:-translate-y-4 tw:scale-75 tw:pt-2 tw:top-4 tw:z-10 tw:origin-[0] 
                                  tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:translate-y-0 tw:peer-placeholder-shown:pt-0
                                  tw:peer-focus:scale-75 tw:peer-focus:-translate-y-4 tw:peer-focus:pt-2
                                   tw:w-full
                                  "
                      >
                        {t("login.password")}
                      </label>
                      <div
                        onClick={togglePasswordVisibility2}
                        style={{
                          position: 'absolute',
                          right: '16px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                          zIndex: 5,
                          display: 'flex',
                          alignItems: 'center',
                          padding: '4px'
                        }}
                      >
                        {showPassword2 ? (
                          <EyeIcon />
                        ) : (
                          <EyeOffIcon />
                        )}
                      </div>
                    </div>
                  </div>
                  <a
                    href="/forgot-password"
                    className="tw:font-hanken-grotesk tw:!text-[#8D8D8D] tw:italic tw:text-sm"
                  >
                    {t("login.forgot_password")}
                  </a>
                </div>
                <div className="tw:!space-y-3 tw:mt-6 tw:text-center">
                  <button
                    name=""
                    id=""
                    type="submit"
                    className="tw:!w-full tw:!bg-[#D4B055] tw:h-[50px] tw:!rounded-md tw:!text-white tw:!flex tw:items-center tw:!justify-center tw:gap-[10px] tw:leading-5"
                    href="#"
                    role="button"
                  >
                    <div className="tw:font-hanken-grotesk tw:font-bold tw:text-sm">
                      {t("login.login")}
                    </div>
                    <FiArrowRight size={24} />
                  </button>
                  <div>
                    <Link
                      href="#"
                      className="tw:!no-underline"
                      to="/login?is_register=true"
                      style={{ fontSize: "14px" }}
                    >
                      <span
                        className="tw:font-hanken-grotesk tw:text-[#212529]"
                        dangerouslySetInnerHTML={{
                          __html: t("login.sign_up_link"),
                        }}
                      ></span>
                    </Link>
                  </div>
                </div>
              </form>

              <div className="tw:flex tw:items-center tw:space-x-4 tw:mt-6">
                <div className="tw:bg-[#EEEEEE] tw:h-[1px] tw:flex-1"></div>
                <div className="tw:font-hanken-grotesk tw:text-[#212529] tw:text-sm tw:whitespace-nowrap tw:flex-shrink-0 tw:capitalize">
                  {t("login.or_google")}
                </div>
                <div className="tw:bg-[#EEEEEE] tw:h-[1px] tw:flex-1"></div>
              </div>
              <div className="justify-content-center tw:mt-6">
                <div>
                  <a
                    name=""
                    id=""
                    className="tw:!h-[50px] tw:flex tw:items-center tw:justify-center tw:rounded-md tw:border tw:border-[#8D8D8D] tw:!no-underline tw:space-x-[10px]"
                    role="button"
                    onClick={handleSignInGoogle}
                  >
                    <img
                      src={googleIcon}
                      className="img-fluid"
                      alt="Efficiency"
                    />
                    <span className="tw:font-hanken-grotesk tw:text-[#282828] tw:text-sm">
                      {t("login.continue_w_google")}
                    </span>
                  </a>
                </div>
                {isBooking ? (
                  <div className="col-6 d-grid text-center ">
                    <button
                      type="button"
                      name=""
                      id=""
                      className="btn btn-secondary rounded py-2 px-4 m-0"
                      href="#"
                      role="button"
                      onClick={book}
                      data-bs-dismiss="modal"
                    >
                      <ProfileIcon />
                      &nbsp; {t("login.continue_as_guest")}
                    </button>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              {/* END FORM */}
            </div>
          </form>
        </>
      )}
    </Fragment>
  );
};

CustomerLogin.propTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { login })(CustomerLogin);
